import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useTranslation } from "react-i18next";
import * as shopActions from "../../actions/shop";
import "./DeliveryDate.scss";

const formatDate = (date) => {
  if (!date) return "";

  const value = String(date).trim();

  if (value.includes("-")) {
    return value.replaceAll("-", " ");
  }

  return value;
};

const getDateValue = (item) => {
  if (!item) return "";

  if (typeof item === "string") {
    return item.trim();
  }

  if (typeof item === "object") {
    return String(
      item.date ||
        item.value ||
        item.plannedDeliveryDate ||
        item.deliveryDate ||
        ""
    ).trim();
  }

  return String(item).trim();
};

const DeliveryDate = ({
  className = "",
  label,
  date,
  dates,
  getDates,
  setNewDate,
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  const defaultLabel = t("delivery.selectDate", t("deliveryDate"));

  const datesArray = Array.isArray(dates) ? dates : [];

  const currentDate = getDateValue(date);
  const firstDate = datesArray.length ? getDateValue(datesArray[0]) : "";
  const selectedDate = currentDate || firstDate;

  useEffect(() => {
    if (!datesArray.length) {
      getDates();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSelect = (newDate) => {
    const value = getDateValue(newDate);

    if (!value) return;

    setNewDate(value);
    setOpen(false);
  };

  return (
    <div className={`delivery-date ${className}`} ref={wrapperRef}>
      <span className="delivery-date__label">{label || defaultLabel}</span>

      <div className="delivery-date__dropdown">
        <button
          type="button"
          className={`delivery-date__button ${open ? "active" : ""}`}
          onClick={() => setOpen(!open)}
          disabled={!datesArray.length}
        >
          {selectedDate ? formatDate(selectedDate) : "..."}
          <span>&gt;</span>
        </button>

        {open ? (
          <div className="delivery-date__list">
            {datesArray.map((item) => {
              const value = getDateValue(item);

              if (!value) return null;

              return (
                <button
                  type="button"
                  key={value}
                  className={
                    String(value) === String(selectedDate)
                      ? "delivery-date__option active"
                      : "delivery-date__option"
                  }
                  onClick={() => handleSelect(value)}
                >
                  {formatDate(value)}
                </button>
              );
            })}
          </div>
        ) : null}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  dates: state.shop.dates,
  date: state.shop.date,
});

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(shopActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryDate);